export default __webpack_public_path__ + "static/working-late-726e18e574bf1d626eb0a35514a8e1d7.svg";